import React from "react";
import { IconButton, InputAdornment, Box } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Controls from "../controlElement/Controls";

export default function Multiline(props) {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        handeOnChange,
        getEvaluatedValue,
        encryptionDecryptions,
        handleEncryptionDecryption
    } = props;

    const value = comp?.rule
        ? getEvaluatedValue(comp.rule)
        : data[controleId] || "";

        // console.log("comp", comp)
    return (
        <Box mb={2}>
            <Controls.Input
                id={controleId}
                name={controleId}
                label={comp.label}
                multiline
                rows={2}
                required={comp.isRequired}
                value={value}
                onChange={handeOnChange}
                disabled={isDisabled}
                error={errors[controleId]}
                data-encryption={comp.encryptionValidate}
                InputProps={{
                    endAdornment: comp.encryptionValidate && (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={() => handleEncryptionDecryption(controleId)}
                            >
                                {encryptionDecryptions[controleId] === "" ? (
                                    <VisibilityOff fontSize="small" />
                                ) : (
                                    <Visibility fontSize="small" />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ),
                    sx: {
                        backgroundColor: `${!value ? "#f0f0f0" : "#ffffff"}`,
                    }
                }}
                sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#555555",
                        color: "#555555",
                        opacity: 0.9,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#333333",
                        opacity: 1,
                    },
                    '& .MuiInputBase-root textarea': {
                        resize: 'both', // or 'vertical' or 'horizontal' as per your need
                        overflow: 'auto'
                    },
                     "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                }}
                className={comp?.cssclass || ""}
            />
        </Box>
    );
}
